// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Notify from "@adl/App/Components/Notify";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import { TypographyPresentationProps } from "@insite/mobius/Typography";

import * as React from "react";
import { FC } from "react";
import { css } from "styled-components";

export interface NotStockedMsgProps {
    productNumber?: string;
}

type Props = NotStockedMsgProps;

export interface NotStockedMsgStyles {
    isStockedMsg?: TypographyPresentationProps;
    notifyExtendedStyles?: TypographyPresentationProps;
}

export const notStockedMsgStyles: NotStockedMsgStyles = {
    isStockedMsg: {
        css: css`
            font-size: 12px;
            font-weight: 600;
            line-height: 18px;
        `,
    },
    notifyExtendedStyles: {
        css: css`
            padding: 5px 10px;
            line-height: 12px;
            margin-top: 5px;
            min-width: 140px;
            max-width: fit-content;
        `,
    },
};

const NotStockedMsg: FC<Props> = productNumber => {
    return (
        <Notify
            showClose={false}
            type="warning"
            data-test-selector="notStocked_errorMessage"
            key={`notStockedError_${productNumber}`}
            {...notStockedMsgStyles.notifyExtendedStyles}
        >
            <StyledWrapper {...notStockedMsgStyles.isStockedMsg}>{siteMessage("Product_Not_Returnable")}</StyledWrapper>
        </Notify>
    );
};

export default NotStockedMsg;
